// src/composables/useRouteMeta.ts
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import type { Component } from 'vue';
import { DefaultLayout } from '../layouts/layouts';

export interface RouteLayoutMeta<TFormConfig = unknown> {
  layoutComponent: Component;
  layoutPageTitle?: string;
  backButton?: boolean;
  formConfig?: TFormConfig;
}

export function useRouteMeta<TFormConfig = unknown>() {
  const route = useRoute();

  const layoutComponent = computed<Component>(() => {
    // fall back to DefaultLayout if not provided
    return (route.meta.layoutComponent as Component | undefined) || DefaultLayout;
  });

  const layoutPageTitle = computed<string | undefined>(() => {
    return route.meta.layoutPageTitle as string | undefined;
  });

  const backButton = computed<boolean | undefined>(() => {
    return route.meta.backButton as boolean | undefined;
  });

  const formConfig = computed<TFormConfig | undefined>(() => {
    return route.meta.formConfig as TFormConfig | undefined;
  });

  const layoutMeta = computed<RouteLayoutMeta<TFormConfig>>(() => ({
    layoutComponent: layoutComponent.value,
    layoutPageTitle: layoutPageTitle.value,
    backButton: backButton.value,
    formConfig: formConfig.value,
  }));

  return {
    route,
    layoutComponent,
    layoutPageTitle,
    backButton,
    formConfig,
    layoutMeta,
  };
}
